import { Component } from 'react';
import { observer } from 'mobx-react';
import { action, observable, computed } from 'mobx';
import moment from 'moment';
import { padStart } from 'lodash';

import Remaining from './Remaining';

@observer
export default class CountDown extends Component {
  @observable secondsRemaining = this.props.remaining;

  constructor(props) {
    super(props);
    if (props.remaining > 0) {
      this.intervalHandle = setInterval(this.tick, 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalHandle);
  }

  @action tick = () => {
    this.secondsRemaining--;
    if (this.secondsRemaining <= 0) {
      clearInterval(this.intervalHandle);
    }
  };

  @computed get duration() {
    return moment.duration(this.secondsRemaining * 1000);
  }

  @computed get status() {
    if (!this.secondsRemaining) {
      return 'expired';
    } else if (this.secondsRemaining < 60 * 60 * (this.props.warnAt || 4)) {
      return 'warn';
    } else {
      return 'normal';
    }
  }

  render() {
    const { children: render } = this.props;

    const timeLeft = {
      days: this.duration.get('days'),
      hours: this.duration.get('hours'),
      minutes: this.duration.get('minutes'),
      seconds: padStart(this.duration.get('seconds'), 2, '0'),
    };

    return render({
      status: this.status,
      duration: this.duration,
      Remaining: Remaining,
      timeLeft: `${timeLeft.days ? `${timeLeft.days}d ` : ''}${timeLeft.hours ? `${timeLeft.hours}h ` : ''}${
        timeLeft.minutes ? `${timeLeft.minutes}m ` : ''
      } ${timeLeft.seconds}s`,
    });
  }
}
